// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"ke_a"};